import { WebhookSubscription } from "./WebhookSubscription";

export class Webhook {
	Guid: string;
	Name: string;
	Enabled: boolean;
	Description: string;
	Created: Date;
	Updated: Date;

	WebhookSubscription: WebhookSubscription[];

	public constructor(init?: Partial<Webhook>) {
		Object.assign(this, init);
	}
}
